import { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  ru: {
    // Header
    logo: "SKINKOSH",
    charts: "Графики",
    myExchanges: "Мои обмены",
    
    // Hero
    heroTitle1: "МОЛНИЕНОСНЫЙ",
    heroTitle2: "ОБМЕН",
    heroTitle3: "КРИПТОВАЛЮТ",
    heroSubtitle: "Обменивайте криптовалюту по выгодным курсам. Быстро. Безопасно. Надежно.",
    
    // Calculator
    youSend: "Отдаёте",
    youReceive: "Получаете",
    exchange: "Обменять",
    selectCurrency: "Выберите валюту",
    search: "Поиск...",
    
    // Exchange Form
    email: "Email для уведомлений",
    wallet: "Адрес кошелька для получения",
    telegram: "Telegram для связи",
    optional: "опционально",
    createRequest: "Создать заявку",
    
    // Payment
    paymentInfo: "Информация для оплаты",
    sendExactly: "Отправьте точно",
    toAddress: "На адрес",
    depositTag: "Memo/Tag для депозита",
    copyAddress: "Скопировать адрес",
    copied: "Скопировано!",
    timeRemaining: "Осталось времени",
    status: "Статус",
    
    // Statuses
    statusPending: "Ожидание",
    statusAwaitingConfirmation: "Ожидание подтверждения",
    statusDepositConfirmed: "Депозит подтверждён",
    statusProcessing: "Обработка",
    statusCompleted: "Завершено",
    statusCancelled: "Отменено",
    
    // Success
    exchangeCompleted: "Обмен завершен!",
    fundsWillBeSent: "Средства будут отправлены на указанный кошелек",
    backToHome: "Вернуться на главную",
    
    // Features
    feature1Title: "Быстро",
    feature1Desc: "Обмен за несколько минут",
    feature2Title: "Безопасно",
    feature2Desc: "Защищённые транзакции",
    feature3Title: "Глобально",
    feature3Desc: "Работаем по всему миру",
    
    // Admin
    admin: "Админ-панель",
    rates: "Курсы",
    requests: "Заявки",
    bybit: "Bybit",
    logout: "Выйти",
    syncRates: "Синхронизировать курсы",
    checkDeposits: "Проверить депозиты",
    balance: "Баланс аккаунта",
    prices: "Курсы",
    autoExchange: "Авто-обмен",
    tradeOnly: "Только торговля",
    complete: "Завершить",
    cancel: "Отменить",
    
    // Rate History
    rateHistory: "История курсов",
    update: "Обновить",
    hours: "ч",
    chartFor: "График курсов за",
    noData: "Нет данных для отображения",
    
    // Language
    language: "Язык",
  },
  en: {
    // Header
    logo: "SKINKOSH",
    charts: "Charts",
    myExchanges: "My Exchanges",
    
    // Hero
    heroTitle1: "LIGHTNING",
    heroTitle2: "CRYPTO",
    heroTitle3: "EXCHANGE",
    heroSubtitle: "Exchange cryptocurrency at the best rates. Fast. Secure. Reliable.",
    
    // Calculator
    youSend: "You Send",
    youReceive: "You Receive",
    exchange: "Exchange",
    selectCurrency: "Select currency",
    search: "Search...",
    
    // Exchange Form
    email: "Email for notifications",
    wallet: "Wallet address to receive",
    telegram: "Telegram for contact",
    optional: "optional",
    createRequest: "Create Request",
    
    // Payment
    paymentInfo: "Payment Information",
    sendExactly: "Send exactly",
    toAddress: "To address",
    depositTag: "Deposit Memo/Tag",
    copyAddress: "Copy address",
    copied: "Copied!",
    timeRemaining: "Time remaining",
    status: "Status",
    
    // Statuses
    statusPending: "Pending",
    statusAwaitingConfirmation: "Awaiting confirmation",
    statusDepositConfirmed: "Deposit confirmed",
    statusProcessing: "Processing",
    statusCompleted: "Completed",
    statusCancelled: "Cancelled",
    
    // Success
    exchangeCompleted: "Exchange completed!",
    fundsWillBeSent: "Funds will be sent to the specified wallet",
    backToHome: "Back to home",
    
    // Features
    feature1Title: "Fast",
    feature1Desc: "Exchange in minutes",
    feature2Title: "Secure",
    feature2Desc: "Protected transactions",
    feature3Title: "Global",
    feature3Desc: "Working worldwide",
    
    // Admin
    admin: "Admin Panel",
    rates: "Rates",
    requests: "Requests",
    bybit: "Bybit",
    logout: "Logout",
    syncRates: "Sync Rates",
    checkDeposits: "Check Deposits",
    balance: "Account Balance",
    prices: "Prices",
    autoExchange: "Auto Exchange",
    tradeOnly: "Trade Only",
    complete: "Complete",
    cancel: "Cancel",
    
    // Rate History
    rateHistory: "Rate History",
    update: "Update",
    hours: "h",
    chartFor: "Chart for",
    noData: "No data to display",
    
    // Language
    language: "Language",
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('skinkosh_language');
    return saved || 'ru';
  });

  useEffect(() => {
    localStorage.setItem('skinkosh_language', language);
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['en']?.[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ru' ? 'en' : 'ru');
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

export default LanguageContext;
